import { Chip } from "@mui/material";
import { FunctionalGroupMembership } from "src/types";

type Props = {
  memberships: FunctionalGroupMembership[] | undefined;
  size?: "small" | "medium";
};

export const FunctionalGroupChips = ({ memberships, size = "small" }: Props) => {
  if (!memberships || memberships.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1">
      {memberships.map((m) => (
        <Chip
          key={m.id}
          label={m.functionalGroup.acronym}
          size={size}
          title={m.functionalGroup.name}
          variant="outlined"
          color="primary"
        />
      ))}
    </div>
  );
};
